import React from 'react';
import { StepCardProps, StepFieldProps, StepHeaderProps, StepFormContainerProps } from './types';

export const StepCard = ({ children }: StepCardProps) => (
  <div className="small-12">
    <div className="pxw-step-card">{children}</div>
  </div>
);

export const StepField = ({
  label,
  children,
  fullWidth = false,
  wide = false,
  required = true,
}: StepFieldProps) => (
  <div className={wide ? 'pxw-field pxw-field--wide' : fullWidth ? 'pxw-field pxw-field--full' : 'pxw-field'}>
    <p className="pxw-field-label">
      {label}
      {required && <span className="pxw-required-star">*</span>}
    </p>
    {children}
  </div>
);

export const StepHeader = ({ title, subtitle }: StepHeaderProps) => (
  <div className="pxw-card-header">
    <h4 className="pxw-step-heading">{title}</h4>
    {subtitle && <p className="pxw-step-subtitle">{subtitle}</p>}
  </div>
);

export const StepFormContainer = ({ children }: StepFormContainerProps) => (
  <form className="pxw-step-form" autoComplete="off" onSubmit={(e) => e.preventDefault()}>
    {children}
  </form>
);
